var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('SpaNav',{attrs:{"selectIndex":"4-1"}}),_c('MobileNavBar',{attrs:{"currentActive":3}}),_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }